<script setup lang="ts">
const props = defineProps<{
  count?: number
}>()
</script>

<template>
  <div class="w-full">
    <div class="flex flex-row flex-nowrap gap-x-1">
      <div
        v-for="(_, index) in props.count || 6"
        :key="index"
        class="hidden h-96 shrink-0 flex-grow animate-pulse bg-neutral-200"
        :class="{
          '!block': index === 0,
          'sm:block': index === 1,
          'lg:block': index === 2,
          'xl:block': index === 3,
          '2xl:block': index >= 4,
        }"
      ></div>
    </div>
  </div>
</template>
